import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LOGO } from "../../lib/content";
import { toast } from "sonner";

export default function AdminLogin() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(email, password);
      toast.success("Welcome.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--crest-black)] text-[var(--crest-cream)] on-dark flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <Link to="/" className="inline-block mb-12" data-testid="admin-login-home">
          <img src={LOGO.whiteOnBlack} className="h-20 w-20 object-contain" alt="Upper Crest Image" />
        </Link>
        <h1 className="font-serif text-4xl tracking-tight">Sign in.</h1>
        <p className="text-[var(--crest-cream)]/60 mt-3">Authorized UCImage Admins Only.</p>
        <form onSubmit={submit} className="mt-12 space-y-1" data-testid="admin-login-form">
          <input type="email" required placeholder="Email" className="crest-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          <input type="password" required placeholder="Password" className="crest-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          <button className="btn-primary mt-8 w-full" style={{ background: "var(--crest-gold)", color: "var(--crest-black)", borderColor: "var(--crest-gold)" }} disabled={loading} data-testid="admin-login-submit">
            {loading ? "Signing in..." : "Enter Portal"}
          </button>
        </form>
      </div>
    </div>
  );
}

